import React, { useEffect, useState } from 'react'
import { v3_ncr_comment, v3_ncr_comment_change_favourite_status, v3_ncr_comment_status_update } from '../../../actions/v3/ncr'
import { toast } from 'react-toastify'
import { v3_upload_plan_approval_document } from '../../../actions/v3/planApproval'
import { FaPlus, FaTrash } from 'react-icons/fa'
import CreatableSelect from 'react-select/creatable';
import { v4_fetch_mailbox_recipients, v4_mailbox_configuration } from '../../../actions/v4/mailBox';
import { filterRecipientOption, mapRecipientOptions } from '../../MailBox/recipientSelectUtils';
import { uploadSelectedFiles } from '../../../utils/multipleFileUpload';

const getUploadedFiles = (files = []) => (
    Array.isArray(files)
        ? files.filter((file) => file?.fileName && file?.originalFileName)
        : []
);

const Comment = ({ ncrId, selectComment, filterPayload, setContributor, setStatusCount, setNcrDetail, onUpdateStatus }) => {
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [data, setData] = useState({ comments: [], total: 0 })
    const [loading, setLoading] = useState(false)
    const [refresh, setRefresh] = useState(false)
    const [mailBoxes, setMailBox] = useState([]);



    useEffect(() => {
        fetchComments(page, true)
    }, [ncrId, refresh, filterPayload])

    const fetchComments = async (pageNo, reset = false) => {
        setLoading(true)
        debugger
        const res = await v3_ncr_comment(pageNo, limit, ncrId, btoa(JSON.stringify(filterPayload)))
        if (res.status) {
            const newComments = res.result.comments
            const uniqueNew = newComments.filter(
                c => !data.comments.some(existing => existing.ID === c.ID)
            )

            setData(prev => ({
                total: res.result.total,
                comments: reset ? res.result.comments : [...prev.comments, ...uniqueNew],
            }))
            setStatusCount(res.result?.statusCountMap)
            setNcrDetail(res.result?.ncrDetail)
            setContributor(res.result.contributor)
        }
        setLoading(false)
    }

    const onChangeFavouriteStatus = (payload) => {
        v3_ncr_comment_change_favourite_status({ ...payload, ncrId }).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setPage(1)
                setData({ comments: [], total: 0 })
                setRefresh(!refresh)
            }
        })
    }


    const [statusState, setStatusState] = useState({
        status: {
            name: 'status', value: '', error: '', options: ['Draft', 'Opened', 'Accepted', 'Archived'], isRequired: true
        },
        remarks: { name: 'remarks', value: '', error: '', isRequired: false },
        title: { name: 'title', value: '', isRequired: true, error: '' },

        comment: { name: 'comment', value: '', error: '', isRequired: true },
        document: { name: 'document', value: [{ fileName: '', originalFileName: '', existing: false }], isRequired: false, error: '' },
        sentEmail: { name: 'sentEmail', value: false, isRequired: false, error: '' },

        fromEmailId: { name: 'fromEmailId', value: '', error: '', isRequired: false },
        email: { name: 'email', value: [], options: [], error: '', isRequired: false },
        subject: { name: 'subject', value: '', error: '', isRequired: false },
        body: { name: 'body', value: '', error: '', isRequired: false },
        cc: { name: 'cc', value: [], options: [], error: '', isRequired: false },
    })

    useEffect(() => {
        v4_fetch_mailbox_recipients().then((res) => {
            if (res.status) {
                const options = mapRecipientOptions(res.result);
                setStatusState((prev) => ({
                    ...prev,
                    ['email']: {
                        ...prev['email'], options
                    },
                    ['cc']: {
                        ...prev['cc'], options
                    },
                }));
            }
        })
    }, [])
    useEffect(() => {
        if (statusState.sentEmail.value && mailBoxes.length === 0) {
            v4_mailbox_configuration().then((res) => {
                if (res.status) {
                    setMailBox(res.result);

                }
            });
        }
    }, [statusState.sentEmail.value]);

    const handleStatusStateChange = (e) => {
        const { name, value } = e.target;
        setStatusState(prev => ({
            ...prev,
            [name]: { ...prev[name], value, error: '' }
        }));
    };
    const handleStatusFileChange = async (index, files) => {
        const uploadedFiles = await uploadSelectedFiles(files, v3_upload_plan_approval_document);
        if (!uploadedFiles.length) return;

        setStatusState(prev => {
            const updatedFiles = [...prev.document.value];
            updatedFiles.splice(index, 1, ...uploadedFiles.map((file) => ({ ...file, existing: false })));
            return {
                ...prev,
                document: { ...prev.document, value: updatedFiles, error: '' }
            };
        });
    };

    const handleStatusUpdateSubmit = (commentId) => {

        // 1. Validate required fields
        let isValid = true;
        const updatedState = { ...statusState };

        Object.keys(statusState).forEach((key) => {
            if (statusState[key].isRequired && !statusState[key].value) {
                updatedState[key].error = 'This field is required';
                isValid = false;
            }
        });

        setStatusState(updatedState);
        if (!isValid) {
            toast.error('Please fill all required fields.');
            return;
        }


        const toEmails = statusState.email.value.map((e) => e.value);
        const ccEmails = statusState.cc.value.map((e) => e.value);


        // 2. Build payload
        const payload = {
            remarks: statusState.remarks.value,
            status: statusState.status.value,
            ncrId,
            commentId,
            commentTitle: statusState.title.value,
            comment: statusState.comment.value,
            document: getUploadedFiles(statusState.document.value),
            revisionId: data?.ID,
            sentEmail: statusState.sentEmail.value,
            to: toEmails,
            subject: statusState.subject.value,
            html: statusState.body.value,
            id: statusState.fromEmailId.value,
            cc: ccEmails
        };

        v3_ncr_comment_status_update(payload).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                setRefresh(!refresh)
                const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${commentId}`));
                if (modal) modal.hide();
            }
            else {
                toast.error(res.error || res.error.message)
            }
        })
    };

    const handleMultiSelectChange = (selectedOptions, name) => {

        setStatusState((prev) => ({
            ...prev,
            [name]: {
                ...prev[name],
                value: selectedOptions,
                error: '',
            },
        }));
    };



    return (
        <React.Fragment>
            {data.comments.length > 0 && data.comments.map((item, index) => {
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
                return (
                    <div key={item.ID}>
                        <div className="plan-item-section">
                            <div className="plan-item-details">
                                <div className="plan-modal">
                                    <p onClick={() => {
                                        selectComment(item.ID)
                                    }}>{index + 1}. {item.TITLE}</p>
                                    <p
                                        onClick={() => {
                                            selectComment(item.ID)
                                        }}
                                    >{item.COMMENT}</p>
                                    <div className="paln-signatur">
                                        <div className="plan-about-user">
                                            <p>Create By <span>{item.CREATED_BY_NAME}</span></p>
                                            <p className="cat-para">{item.STATUS}</p>

                                        </div>
                                        <div className="plan-about-user-copy">

                                            <p

                                            >
                                                <i
                                                    data-bs-toggle="modal"
                                                    data-bs-target={`#statusUpdateModal-${item.ID}`}
                                                    className="bx bx-edit"
                                                    aria-hidden="true"
                                                    onClick={() => {

                                                        setStatusState(prev => ({
                                                            ...prev,
                                                            status: {
                                                                ...prev.status,
                                                                value: item.STATUS
                                                            },
                                                            title: {
                                                                ...prev.title,
                                                                value: item.TITLE
                                                            },
                                                            comment: {
                                                                ...prev.status,
                                                                value: item.COMMENT
                                                            },
                                                            document: {
                                                                ...prev.status,
                                                                value: item.documents.length > 0 ? item.documents.map((doc) => {
                                                                    return {
                                                                        fileName: doc.FILE_NAME, originalFileName: doc.ORIGINAL_FILE_NAME, existing: true
                                                                    }
                                                                }) : [{ fileName: '', originalFileName: '', existing: false }]
                                                            }
                                                        }));
                                                    }}
                                                />
                                                <div
                                                    className="modal fade"
                                                    id={`statusUpdateModal-${item.ID}`}
                                                    data-bs-backdrop="static"
                                                    data-bs-keyboard="false"
                                                    tabIndex={-1}
                                                    role="dialog"
                                                    aria-labelledby="statusUpdateModalLabel"
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="statusUpdateModalLabel">
                                                                    Update Status
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                />
                                                            </div>
                                                            <div className="modal-body">
                                                                <div className="row">
                                                                    <div className="col-md-12 mb-3">
                                                                        <label>Status {statusState.status.isRequired && <span className='text-danger'> *</span>}</label>
                                                                        <select
                                                                            name={'status'}
                                                                            value={statusState['status'].value}
                                                                            onChange={handleStatusStateChange}
                                                                            className={`form-control ${statusState['status'].error ? 'is-invalid' : ''}`}
                                                                        >
                                                                            <option value=''>Select Status</option>
                                                                            {statusState.status.options.map((status) => {
                                                                                return (
                                                                                    <option value={status}>{status}</option>

                                                                                )
                                                                            })}
                                                                        </select>
                                                                        {statusState['status'].error && <div className="invalid-feedback">{statusState['status'].error}</div>}
                                                                    </div>
                                                                    {statusState.status.value === 'Draft' &&
                                                                        <>
                                                                            <div className="col-md-12 mb-3">
                                                                                <label>Title <span >*</span></label>
                                                                                <input
                                                                                    name={'title'}
                                                                                    placeholder='Enter Title'
                                                                                    value={statusState['title'].value}
                                                                                    onChange={(e) => {
                                                                                        const { name, value } = e.target;
                                                                                        setStatusState(prev => ({
                                                                                            ...prev,
                                                                                            [name]: { ...prev[name], value, error: '' }
                                                                                        }));
                                                                                    }}
                                                                                    className={`form-control ${statusState['title'].error ? 'is-invalid' : ''}`}
                                                                                />
                                                                                {statusState['title'].error && <div className="invalid-feedback">{statusState['title'].error}</div>}
                                                                            </div>
                                                                            <div className="col-md-12 mb-3">
                                                                                <label>Comment <span >*</span></label>
                                                                                <textarea
                                                                                    row='2'
                                                                                    name={'comment'}
                                                                                    placeholder='Enter Comment'
                                                                                    value={statusState['comment'].value}
                                                                                    onChange={(e) => {
                                                                                        const { name, value } = e.target;
                                                                                        setStatusState(prev => ({
                                                                                            ...prev,
                                                                                            [name]: { ...prev[name], value, error: '' }
                                                                                        }));
                                                                                    }}
                                                                                    className={`form-control ${statusState['comment'].error ? 'is-invalid' : ''}`}
                                                                                />
                                                                                {statusState['comment'].error && <div className="invalid-feedback">{statusState['comment'].error}</div>}
                                                                            </div>
                                                                            <div className="col-md-12 mb-3">
                                                                                <label>Supporting File <span >*</span></label>
                                                                                {statusState.document.value.map((item, index) => (
                                                                                    <div key={index} className="d-flex align-items-center mb-2">
                                                                                        {item.fileName ? (
                                                                                            <>
                                                                                                <div className="me-2 flex-grow-1">
                                                                                                    <span>{item.originalFileName}</span>
                                                                                                </div>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-danger"
                                                                                                    onClick={() => {

                                                                                                        const updatedFiles = statusState.document.value.filter((_, i) => i !== index);
                                                                                                        setStatusState(prev => ({
                                                                                                            ...prev,
                                                                                                            document: {
                                                                                                                ...prev.document,
                                                                                                                value: updatedFiles,
                                                                                                                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
                                                                                                            }
                                                                                                        }));
                                                                                                    }}
                                                                                                >
                                                                                                    <FaTrash />
                                                                                                </button>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <input
                                                                                                    type="file"
                                                                                                    multiple
                                                                                                    onChange={(e) => handleStatusFileChange(index, e.target.files)}
                                                                                                    className="form-control me-2"
                                                                                                />
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn btn-outline-danger"
                                                                                                    onClick={() => {

                                                                                                        const updatedFiles = statusState.document.value.filter((_, i) => i !== index);
                                                                                                        setStatusState(prev => ({
                                                                                                            ...prev,
                                                                                                            document: {
                                                                                                                ...prev.document,
                                                                                                                value: updatedFiles,
                                                                                                                error: updatedFiles.length === 0 ? 'At least one document is required' : ''
                                                                                                            }
                                                                                                        }));
                                                                                                    }}
                                                                                                >
                                                                                                    <FaTrash />
                                                                                                </button>
                                                                                            </>
                                                                                        )}
                                                                                    </div>
                                                                                ))}
                                                                                <div>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-primary"
                                                                                        onClick={() => {
                                                                                            setStatusState(prev => ({
                                                                                                ...prev,
                                                                                                document: {
                                                                                                    ...prev.document,
                                                                                                    value: [...prev.document.value, { fileName: '', originalFileName: '', existing: false }],
                                                                                                    error: ''
                                                                                                }
                                                                                            }));
                                                                                        }}
                                                                                    >
                                                                                        <FaPlus className="me-1" /> Add Document
                                                                                    </button>
                                                                                </div>
                                                                                {statusState['document'].error && <div className="invalid-feedback">{statusState['document'].error}</div>}
                                                                            </div>
                                                                        </>

                                                                    }

                                                                    <div className="col-md-12 mb-3">
                                                                        <label>Send Email ? </label>
                                                                        &nbsp;
                                                                        &nbsp;
                                                                        <input
                                                                            type="checkbox"
                                                                            name={'sentEmail'}
                                                                            checked={statusState.sentEmail.value === true}
                                                                            onChange={(e) => {
                                                                                const checked = e.target.checked;

                                                                                setStatusState(prev => ({
                                                                                    ...prev,
                                                                                    sentEmail: {
                                                                                        ...prev.sentEmail,
                                                                                        value: checked,
                                                                                    },
                                                                                    fromEmailId: {
                                                                                        ...prev.fromEmailId,
                                                                                        isRequired: checked,
                                                                                    },
                                                                                    email: {
                                                                                        ...prev.email,
                                                                                        isRequired: checked,
                                                                                    },
                                                                                    subject: {
                                                                                        ...prev.subject,
                                                                                        isRequired: checked,
                                                                                    },
                                                                                    body: {
                                                                                        ...prev.body,
                                                                                        isRequired: checked,
                                                                                    },
                                                                                }));
                                                                            }}
                                                                            className={`mt-1 form-check-input ${statusState['sentEmail'].error ? 'is-invalid' : ''}`}
                                                                        />
                                                                    </div>
                                                                    {statusState.sentEmail.value &&
                                                                        <div>
                                                                            <div className="mb-3">
                                                                                <select
                                                                                    isMulti
                                                                                    name="fromEmailId"
                                                                                    value={statusState.fromEmailId.value}
                                                                                    onChange={handleStatusStateChange}
                                                                                    className="form-select"
                                                                                >
                                                                                    <option value={''}> Send From </option>
                                                                                    {mailBoxes?.map((mail) => {
                                                                                        return (
                                                                                            <option value={mail.ID}>{mail.EMAIL} </option>
                                                                                        )
                                                                                    })}
                                                                                </select>
                                                                                {statusState.fromEmailId.error && <small className="text-danger">{statusState.fromEmailId.error}</small>}
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <CreatableSelect
                                                                                    isMulti
                                                                                    name="email"
                                                                                    value={statusState.email.value}
                                                                                    options={statusState.email.options} // Optional: preload some emails if needed
                                                                                    filterOption={filterRecipientOption}
                                                                                    onChange={(e) => handleMultiSelectChange(e, 'email')}
                                                                                    className="basic-multi-select"
                                                                                    classNamePrefix="select"
                                                                                    placeholder="To"
                                                                                    isClearable
                                                                                />
                                                                                {statusState.email.error && <small className="text-danger">{statusState.email.error}</small>}
                                                                            </div>
                                                                            {statusState.email.value.length > 0 && <div className="mb-3">
                                                                                <CreatableSelect
                                                                                    isMulti
                                                                                    name="cc"
                                                                                    value={statusState.cc.value}
                                                                                    options={statusState.cc.options} // Optional: preload some emails if needed
                                                                                    filterOption={filterRecipientOption}
                                                                                    onChange={(e) => handleMultiSelectChange(e, 'cc')}
                                                                                    className="basic-multi-select"
                                                                                    classNamePrefix="select"
                                                                                    placeholder="CC"
                                                                                    isClearable
                                                                                />
                                                                                {statusState.cc.error && <small className="text-danger">{statusState.cc.error}</small>}
                                                                            </div>}
                                                                            <div className="mb-3">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control"
                                                                                    name="subject"
                                                                                    value={statusState.subject.value}
                                                                                    onChange={handleStatusStateChange}
                                                                                    placeholder="Subject"
                                                                                />
                                                                                {statusState.subject.error && <small className="text-danger">{statusState.subject.error}</small>}
                                                                            </div>
                                                                            <div className="mb-3">
                                                                                <textarea
                                                                                    className="form-control"
                                                                                    rows="5"
                                                                                    name="body"
                                                                                    value={statusState.body.value}
                                                                                    onChange={handleStatusStateChange}
                                                                                    placeholder="Write your message..."
                                                                                />
                                                                                {statusState.body.error && <small className="text-danger">{statusState.body.error}</small>}
                                                                            </div>
                                                                        </div>
                                                                    }


                                                                </div>
                                                                <div className="mt-3">
                                                                    <button className="btn btn-success me-2"
                                                                        onClick={() => {
                                                                            handleStatusUpdateSubmit(item.ID)
                                                                        }}
                                                                    >Send</button>

                                                                    <button className="btn btn-danger text-white" onClick={() => {
                                                                        const modal = window.bootstrap.Modal.getInstance(document.getElementById(`statusUpdateModal-${item.ID}`));
                                                                        if (modal) modal.hide();
                                                                    }}>Cancel</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />

                                                <i
                                                    className={`bx ${Number(item.IS_FAVOURITE) ? 'bxs-star' : 'bx-star'}`}
                                                    style={{
                                                        color: Number(item.IS_FAVOURITE) ? '#f1c40f' : '#999',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => {
                                                        onChangeFavouriteStatus({
                                                            commentId: item.ID,
                                                            comment: item.TITLE,
                                                            favouriteStatus: Number(!Number(item.IS_FAVOURITE)),
                                                        })
                                                    }}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="uplodeimageseep">
                            {item.documents.map((doc, i) => {
                                const fileExt = doc.ORIGINAL_FILE_NAME?.split('.').pop()?.toLowerCase()
                                const isImage = imageExtensions.includes(fileExt)
                                const previewUrl = `${process.env.REACT_APP_BASE_URL}/v3/ncr/document/preview/${doc.NCR_ID}/${doc.FILE_NAME}`;
                                const downloadUrl = `${process.env.REACT_APP_BASE_URL}/v3/ncr/document/download/${doc.NCR_ID}/${doc.FILE_NAME}`;

                                return (
                                    <div className="uplodeitem" key={i}>
                                        {isImage && (
                                            <div className="ship-img-box">
                                                <img
                                                    src={previewUrl}
                                                    alt={doc.ORIGINAL_FILE_NAME}
                                                />
                                            </div>
                                        )}
                                        <div className="img-caption">
                                            <p>
                                                <a
                                                    href={previewUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {doc.ORIGINAL_FILE_NAME}
                                                </a>
                                            </p>
                                            <div className="d-flex justify-content-center gap-2">
                                                <a href={previewUrl} target="_blank" rel="noopener noreferrer" className="small text-info">Preview</a>
                                                <a href={downloadUrl} target="_blank" rel="noopener noreferrer" className="small">Download</a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                )
            })}

            {/* Load More Button */}
            {data.comments.length < data.total && (
                <div className="text-center mt-3">
                    <button
                        className="btn btn-primary"
                        disabled={loading}
                        onClick={() => {
                            setPage(prev => {
                                const next = prev + 1
                                fetchComments(next)
                                return next
                            })
                        }}
                    >
                        {loading ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}
        </React.Fragment>
    )
}

export default Comment
